export default __webpack_public_path__ + "static/media/warning.9ee6d55f.png";